import React from 'react';

interface IProps {
  style?: string;
  onOutsideClick: () => void;
}

class OutsideClickHandler extends React.PureComponent<IProps> {
  private wrapperRef: HTMLElement;

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef = (node: HTMLElement) => {
    this.wrapperRef = node;
  }

  handleClickOutside = (event: any) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.onOutsideClick();
    }
  }

  render() {
    const { style, children } = this.props;
    return <div ref={ this.setWrapperRef } className={ style ? style : '' }>{ children }</div>;
  }
}

export default OutsideClickHandler;


// WEBPACK FOOTER //
// ./src/components/Shared/OutsideClickHandler/OutsideClickHandler.tsx